import React from 'react'
import { Typography, Box } from "@mui/material"
import aboutProantra from '../Assets/aboutProantra.mp4'
import ReactPlayer from 'react-player'

// import proaPenta from '../Assets/proaPenta.png'
  
const AboutUs = () => {
  return (
    <Box id = 'aboutUs' sx={{backgroundColor: '#D9D9D9', paddingTop: '6rem', paddingBottom: '3rem'}}> 
       <Typography sx={{fontSize: '3rem', textAlign: 'center', marginBottom: '1rem',
                        '@media (max-with: 442px)': {fontSize: '1.5rem'}}}> 
            About
       </Typography>

        <Typography sx={{fontSize: '1.1rem', color: '#000000', marginBottom: '2rem', textAlign: 'center', paddingLeft: '3rem', paddingRight: '3rem'}}>
            Proantra supports businesses with data harnessing needs. Emphasizing Data Science work that delivers sustaineable value to businesses. Data harnessing is the process of capturing and converting data into actionable insight. We closely collaborate with our clients to understand their data harnessing needs. We prioritize value creation and use state-of-the-art data technology to develop innovative solutions through holistic thinking. We are inspired by the passion for innovative problem solving and powered by diligence and strong collaboration. We strive to take good care of our partners, affiliates and community, every time! Relentless pursuit of excellence is deeply engraved in the DNA of Proantra.
 
      </Typography>

        
       <Typography sx={{fontSize: '1.1rem', color: '#000000', marginBottom: '2rem', textAlign: 'center', paddingLeft: '3rem', paddingRight: '3rem'}}>
            <strong> Our mission: </strong> “Strengthen people and organizations to strengthen communities.”
       </Typography>

       <Box sx={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', 
                 width: '100%', textAlign: 'center', gap: '1rem', marginBottom: '0.25rem'}}>

          <Box sx={{textAlign: 'center' , justifyContent: 'center'}}>
            <ReactPlayer url = {aboutProantra} controls = {true} height = '12rem' width = '20rem' justifyContent = 'center'/>
            <Typography sx={{fontSize: '1.0rem', width: '15rem', textAlign: 'center', fontWeight : 'bold'}}> About Proantra
            </ Typography>

{/*                 <Typography sx={{width: '25rem', textAlign: 'center'}}>
                What Proantra does and how Proantra does it!
                </Typography>  */}   
          </Box> 

          
          <Box sx={{textAlign: 'left'}}>
            <Typography sx={{fontSize: '1.1rem', color: '#000000', marginBottom: '2rem', textAlign: 'center', paddingLeft: '3rem', paddingRight: '3rem'}}>
                Founded by Isaac Owuor who is a highly accomplished innovative leader with over 10 years of experience in industrial engineering and data science in the manufacturing and supply chain space. He holds a master's degree in industrial & systems engineering from the University of Alabama in Huntsville, where he also graduated with a minor in reliability engineering. He earned certificates in data science, artificial intelligence and iOT from Purdue University – through corporate education partnership. Isaac has a proven track record of driving success in process development, analytics, improvement and monitoring using state of the art data technologies. He has also been successful in developing strategy around data analytics. His experience spans Fortune 500 corporations  to innovative start-ups.


            </Typography>

          </Box> 

        </Box> 

        <Typography sx={{fontSize: '1.3rem', color: '#000000', marginBottom: '2rem', textAlign: 'center', paddingLeft: '3rem', paddingRight: '3rem'}}>

               <strong> Core Values: </strong>
        </Typography> 


       <Box sx={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', 
                 width: '100%', textAlign: 'center', gap: '0.01rem', marginBottom: '2rem', 
                 backgroundColor: '#D9D9D9', paddingTop: '0.01rem', paddingBottom: '2rem'}}>
            
            <Box sx={{width: '15rem', borderRadius: '10px', padding: '1.5rem'}}>
                <Typography sx={{fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '0.2rem'}}>
                    Caring:
                </Typography>
                <Typography sx={{fontSize: '1.1rem'}}>
                Take good care of our Partners and our Community with Integrity. Maintain outstanding customer service.

                </Typography>               
            </Box> 

            <Box sx={{width: '15rem', borderRadius: '10px', padding: '1.5rem'}}>
                <Typography sx={{fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '0.2rem'}}>
                    Collaboration:
                </Typography>
                <Typography sx={{fontSize: '1.1rem'}}>
                Develop relationships and build sustainable Partnerships. Our Clients become our Partners.

                </Typography>               
            </Box> 

            <Box sx={{width: '15rem', borderRadius: '10px', padding: '1.5rem'}}>
                <Typography sx={{fontSize: '1.2rem', fontWeight: 'bold', marginBottom: '0.2rem'}}>
                   Diligence:
                </Typography>
                <Typography sx={{fontSize: '1.1rem'}}>
                Persistent effort with resilience, commitment and passion to deliver on our promises.  Diligence with transparency.
                </Typography>               
            </Box>   

            <Box sx={{width: '15rem', borderRadius: '10px', padding: '1.5rem'}}>
                <Typography sx={{fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.2rem'}}>
                Learning:
                </Typography>
                <Typography sx={{fontSize: '1.1rem'}}>
                Perpetual learning with adaptability. Stay ahead of the rapidly evolving technology landscape. Power innovation with knowledge.


                </Typography>               
            </Box> 

            <Box sx={{width: '15rem', borderRadius: '10px', padding: '1.5rem'}}>
                <Typography sx={{fontSize: '1.1rem', fontWeight: 'bold', marginBottom: '0.2rem'}}>
                Innovation:
                </Typography>
                <Typography sx={{fontSize: '1.1rem'}}>
                Continue to developed new, creative and improved ways of solving problems. “Thinking outside of the box”.


                </Typography>                 
            </Box>          

       </Box>
    </Box>
  )
}

export default AboutUs